/**
 * Messenger window title
 */
export const HELP_CENTER_CHAT_MESSENGER_WINDOW_TITLE_230413 =
  'HELP_CENTER_CHAT_MESSENGER_WINDOW_TITLE_230413';
